FD.CONTROL = (function ($, me) {
    'use strict';

    var child = me.CONTROL || {};
    
    /* 
     * ========================================================================
     *  Private Variables
     * ========================================================================
    */


    var ELEM = '[data-fd="radiobutton"]';
    var OFF = 0, ON = 1;
    var iconClasses = [
        'fa-circle-o',
        'fa-dot-circle-o'
    ];
    
    var defaults = {
        useparent: true,        
        parentid: -1,
        callbackprefix: 1,
        value: -1,  
        noedit: false,
        initial: null
    };


    /* 
     * ========================================================================
     *  Private Methods
     * ========================================================================
    */

    
    function setupRadioButtonGroups(container) {
        var list = [];
        if (container) {
            list = container instanceof jQuery ? container.find(ELEM) : $(container).find(ELEM);
        } else {
            list = $(ELEM);
        }
        if (!list.length) {
            return;
        }

        $(document).off('click', ELEM + ' .radioButtonIcon');
        $(document).on('click', ELEM + ' .radioButtonIcon', clickRadioButton);

        list.each(function (index, elem) {
            elem = $(this);
            var options = $.extend({}, defaults, elem.data());
            me.setControlItemOptions(elem, options);
            if (!options.noedit) {
                elem.find('.radioButtonIcon').css({ cursor: 'pointer' });
            }
            if (options.initial !== undefined && options.initial !== null) {
                elem.data('value', options.initial).attr('data-value', options.initial).find('.radioButtonIcon[data-radiovalue="' + options.initial + '"]').removeClass(iconClasses[OFF]).addClass(iconClasses[ON]);
            }
        });
    }


    function clickRadioButton() {
        var elem = $(this), radioButtonContainer = $(this).closest(ELEM);
        var data = radioButtonContainer.data();
        if (data.noedit) {
            return;
        }

        var value = elem.data('radiovalue');
        if (value !== radioButtonContainer.data('value')) {
            radioButtonContainer.data('value', value).attr('data-value', value).find('.' + iconClasses[ON]).removeClass(iconClasses[ON]).addClass(iconClasses[OFF]);
            elem.removeClass(iconClasses[OFF]).addClass(iconClasses[ON]);

            me.setCallBackFromData(radioButtonContainer, { e: elem, value: value, tag: data.tag, parentid: data.parentid });
        }
    }


    /* ========================================================================
     *  public methods
     * ========================================================================
    */


    child.setRadioButton = function (container) {
        setupRadioButtonGroups(container);
    };


    /*
     * Options:
     *  value: set a new selected value for this radio button group programmatically
     *  noedit: enable/disable editing
     */
    child.updateRadioButtonGroup = function (radioButtonGroup, options) {
        if (radioButtonGroup.data('fd') !== 'radiobutton') {
            return;
        }

        if (options.value !== undefined && options.value !== null) {
            radioButtonGroup.find('.' + iconClasses[ON]).removeClass(iconClasses[ON]).addClass(iconClasses[OFF]);
            radioButtonGroup.data('value', options.value).attr('data-value', options.value).find('.radioButtonIcon[data-radiovalue="' + options.value + '"]').removeClass(iconClasses[OFF]).addClass(iconClasses[ON]);
        }
        if (options.noedit !== undefined && options.noedit !== null) {
            radioButtonGroup.data('noedit', options.noedit).attr('data-noedit', options.noedit);
            if (options.noedit) {
                radioButtonGroup.find('.radioButtonIcon').css({ cursor: 'default' });
            } else {
                radioButtonGroup.find('.radioButtonIcon').css({ cursor: 'pointer' });
            }
        }
    }

    /* ========================================================================
     *  return
     * ========================================================================
    */
    return child;
}(jQuery, FD));